export default "__VITE_ASSET__BOzpGhFb__"